import * as React from "react";
import { useState } from "react";

export const ChartLegendToggleButton = (props: any) => {
    const { product, cssWrapper } = props;
    const [isOn, setIsOn] = useState(true);

    return (
        <button
            aria-pressed={isOn}
            onClick={() => {
                setIsOn(!isOn);
                props.onClick(!isOn);
            }}
            className={"chart-legend-toggle-button " + product.cssModifier + cssWrapper}
        >
            <span className={"account-legend " + product.cssModifier}></span>
            <span className="sr-only">Click to toggle</span>
            <span className="account-legend-label">{product.name}</span>
            <span className="icon" aria-hidden={true}></span>
        </button>
    );
};
